export const resolveHref = (href: string) => {
	// Check if the href is already an absolute URL
	// If it is, return it as is
	// If it is not, resolve it against the current window location
	return /^(?:[a-z]+:)?\/\//i.test(href) ? href : new URL(href, window.location.href).href;
};
